export default __webpack_public_path__ + "static/media/icon-services-incident-management.2553eb5b.svg";